export default "__VITE_ASSET__foPqo7fK__"